import React  from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../CC/cc.css';

const Description = () => {
  return (
 <div>
 <img src="https://static.igem.wiki/teams/4272/wiki/des1.png" 
            style={{width:"100%",height:"90vh"}} alt="impl1" />
   
   <br/><br/>
   <Row>
      <Col md={{offset:1}}>
      <h1 style={{color:"#0072F9" ,fontWeight:"bold"}}>Description</h1>
      </Col>
      </Row>

      <br/>
<p style={{width:"75vw",marginLeft:"8vw"}}>
We wanted to make recommended design tools for CRISPR repression systems from ACR proteins generated by natural evolution by reviewing the literature, among others, but the current state of difficulties in the discovery of this class of proteins greatly affects the advancement of our vision. We therefore turned to identifying discoveries for ACR proteins to augment existing ACR protein databases.</p>

<br/>
<Row>
      <Col md={{offset:1}}>
<h1 style={{color:"#0072F9" ,fontWeight:"bold"}}>Details</h1>
</Col>
      </Row>
      <br/>
<h5 style={{width:"75vw",marginLeft:"8vw",fontWeight:"bold"}}>Background (why we choose this?)</h5>
<p style={{width:"75vw",marginLeft:"8vw"}}>
After learning from past studies and reading the relevant literature and cases, we found that the overactivity of existing CRISPR CAS technology instead limits further development of this technology.
</p>
<p style={{width:"75vw",marginLeft:"8vw"}}>
For example, because of excessive activity when applied, Cas enzymes may cause unexpected mutations in sequences outside the target region or bind to the genome for a long time to interfere with the normal function of other functional proteins. There are also more established solutions to this series of problems arising from excessive Cas enzyme activity, such as the use of more highly targeted crRNAs, or the use of Cas inhibitors such as small molecules / nucleic acids to mitigate them.
</p>
<p style={{width:"75vw",marginLeft:"8vw"}}>
However, in practice, the existing schemes do not completely solve these problems.
</p>
<p style={{width:"75vw",marginLeft:"8vw"}}>
Enhanced targeting of crRNAs does reduce the potential for off target effects, but the risks do not fall below the “ safety standard “ and it cannot be said that there are absolutely no other concerns associated with applying this technology to humans. Simultaneous reduction of off target effects also does not address interference of prolonged binding with normal cellular physiological activity.
While small molecules / nucleic acids, etc., can have different degrees of inhibition on Cas enzymes, their expensive price, cytotoxicity, difficulty in meticulously regulating the inhibition strength during use (may be too strong inhibition leading to experimental failure, or too weak inhibition cannot solve the problem) and problems such as possible unknown interactions in other life processes after the introduction of specific nucleic acids or small molecules result in relatively limited progress in applications.


</p>
<h5 style={{width:"75vw",marginLeft:"8vw",fontWeight:"bold"}}>
Inspiration (How We Start?)
</h5>

<p style={{width:"75vw",marginLeft:"8vw"}}>
Our team believes that nature's “ arms race “ should give better answers (Evolution has allowed bacteria to use the CRISPR system to fight viral infections, and evolution has also driven viruses to evolve functions that counter the CRISPR system, the anti cripsr protein we call), querying the literature and learning that there are parts of phages that have emerged such classes of naturally occurring protein Cas enzyme inhibitors (ACR proteins) with less impact on cells, and there is precedent for engineering applications.

</p>

<p style={{width:"75vw",marginLeft:"8vw",fontWeight:"700"}}>

“if we can develop a more liberal design tool for inhibiting systems that can precisely push ACRS of various inhibitory strengths (and the corresponding plasmid designs) depending on the Cas enzyme used, perhaps it will solve the problems of off target effects, interference with normal life activities, cytotoxicity, high price, etc., that exist in the available protocols. “

</p>

<p style={{width:"75vw",marginLeft:"8vw"}}>
But it is precisely due to the multiple inhibitory mechanisms that exist for ACR proteins, resulting in their low sequence conservation that makes it difficult to search for this family of proteins from traditional approaches. The very small number of proteins we were able to push in our early attempts made it nearly impossible to achieve the design tools with the desired high degrees of freedom.
Therefore, we turned to the search for such proteins, hoping to identify by way of more non protein per se sequence features that augment the ACR protein database, etc. proteins in this database are fully validated before considering the development of relevant design aids, and expected to be helpful for subsequent team research through our work.
</p>

<h5 style={{width:"75vw",marginLeft:"8vw",fontWeight:"700"}}>
AcrGPS  (What We Have Done?)

</h5>
<p style={{width:"75vw",marginLeft:"8vw"}}>
We selected HTH, directon, protein length, protein hydrophobicity, protein isoelectric point, based on the characteristics of the CRISPR inhibitors themselves generated in this class of natural evolution by obtaining 136 valid ACR proteins from anti crisprdb and other protein sequences that were not ACR proteins under the same genome to constitute the dataset Features such as protein quality (covering protein physical properties, surrounding genomic features, etc.) are used to build a predictive model based on a random forest algorithm to find the most likely candidates from the input complete genome.

</p>

 </div>

  )
}

export default Description
